import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// PASTE YOUR NEW FIREBASE CONFIGURATION HERE:
const firebaseConfig = {
  apiKey: "AIzaSyDi0PuW52lvosxyfnBS1KmsAX4LtAUeTCs",
  authDomain: "bookmygeo.firebaseapp.com",
  projectId: "bookmygeo",
  storageBucket: "giobilling",
  messagingSenderId: "572761667035",
  appId: "1:572761667035:web:280a12176b061e7520a3fe",
  measurementId: "G-WS4863CRHG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { app, analytics, storage };

